import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { MaybeLocked, LockMark } from './LockedAction';

import './Kebab.css';

/**
 * Kebab do HEADER de página de item — Ciclo 7 · CD 2026-08-07.
 *
 * <p><b>Por que existe.</b> As 5 páginas de detalhe (Turma, Quiz, Exam, Questão,
 * Taxonomia) tinham este menu escrito À MÃO, cada uma com o seu
 * {@code <Dropdown className="kb">} + toggle SVG + {@code popperConfig}. Era a
 * TERCEIRA gramática de kebab do portal — as outras duas (linha e lote) já
 * viviam no {@code DataTable} —, e foi por isso que divergiram: copy diferente
 * ("Ver no Log" × "Ver histórico"), sem ícone, hairline entre TODOS os itens em
 * vez de um só antes do destrutivo, e ordem própria.
 *
 * <p>🔴 <b>Mesmo contrato de ação do {@code DataTable}</b>, de propósito:
 * {@code { handler, label, icon, variant, separatorBefore, guard }}. Um contrato
 * só é o que permite a página do item herdar o kebab da LISTAGEM trocando uma
 * linha — que é a régua: <b>o kebab do header é o da linha menos o que não faz
 * sentido ali</b> (tipicamente "Editar", porque a página JÁ é a edição).
 *
 * <p>⚠️ O `guard` recebe {@code undefined} aqui (não há row) — use closure sobre
 * o state da página: {@code guard: () => isClosed ? 'hide' : null}. Mesmos
 * retornos do DataTable: {@code null} habilitado · {@code 'hide'} não renderiza.
 *
 * <p>⚠️ `renderOnMount` + `strategy: 'fixed'` não são enfeite — são o par que
 * conserta recorte por `overflow` do ancestral e o "primeira abertura no teto".
 * Ver `KEBAB_POPPER` no {@code DataTable}; aqui a razão é a mesma.
 *
 * @param {Array}  actions  itens; `null`/`false` na lista são ignorados
 * @param {string} [ariaLabel] i18n key do aria-label do toggle
 */
export default function PageHeaderKebab({ actions = [], ariaLabel = 'app.feedback.actions' }) {
	const { t } = useTranslation();

	const visible = (actions || [])
		.filter(Boolean)
		.map(a => ({ ...a, guardResult: typeof a.guard === 'function' ? a.guard() : null }))
		.filter(a => a.guardResult !== 'hide');

	if (visible.length === 0) return null;

	return (
		<Dropdown className="kb" align="end">
			<Dropdown.Toggle
				as="button"
				type="button"
				className="kb-toggle"
				bsPrefix="kb-toggle"
				aria-label={t(ariaLabel, 'Ações')}
			>
				<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
					<circle cx="12" cy="5" r="1.7" />
					<circle cx="12" cy="12" r="1.7" />
					<circle cx="12" cy="19" r="1.7" />
				</svg>
			</Dropdown.Toggle>
			<Dropdown.Menu
				className="kb-menu"
				renderOnMount
				popperConfig={{
					strategy: 'fixed',
					modifiers: [
						{ name: 'offset', options: { offset: [0, 4] } },
						{ name: 'preventOverflow', options: { boundary: 'clippingParents' } },
					],
				}}
			>
				{visible.map((action, i) => (
					<React.Fragment key={action.label || i}>
						{/* ⚠️ `&& i > 0`: separador no PRIMEIRO item desenha hairline
						    colado na borda do menu. Era o que acontecia quando o item
						    de histórico vinha primeiro com divider próprio. */}
						{action.separatorBefore && i > 0 && <Dropdown.Divider />}
						{/* 🔴 Cadeado + motivo é o IDIOMA DA CASA pra "por que este comando
						    não funciona aqui" — o `LockedAction`, extraído do plano em
						    2026-08-25. Entrou aqui em 2026-08-30 pra valer em TODO kebab
						    que use `guard`, em vez de cada tela redescobrir.
						    ⚠️ O `<span>` do `MaybeLocked` não é enfeite: item desabilitado
						    NÃO dispara evento de mouse, então o gatilho do tooltip precisa
						    de um elemento vivo por fora. Foi por não saber disso que a
						    primeira versão daqui usou `title` nativo + `pointer-events`. */}
						<MaybeLocked
							locked={!!action.guardResult}
							reason={action.guardResult ? t(action.guardResult) : ''}
							wrapClass="d-block"
						>
							<Dropdown.Item
								className={action.variant === 'danger' ? 'is-danger' : ''}
								disabled={!!action.guardResult}
								onClick={() => { if (!action.guardResult) action.handler(); }}
							>
								{action.icon && (
									<FontAwesomeIcon icon={action.icon} className="kb-item-icon" />
								)}
								<Trans i18nKey={action.label} />
								{action.guardResult && <LockMark />}
							</Dropdown.Item>
						</MaybeLocked>
					</React.Fragment>
				))}
			</Dropdown.Menu>
		</Dropdown>
	);
}
